import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATUlEQVR42m2NsQrAIBBD/f/vK8VOpSCli0MLp1b04iEIimZ6JCFR6BToA71WiJuVVCPOGfa+8Jy68lSIPsDsB8ym8Tu/WGCWwMkNDQsFTwF9PkYwKBEAAAAASUVORK5CYII="};
